import { Controller } from "@hotwired/stimulus"

// Fetches the reCAPTCHA v3 token when the form is submitted instead of relying on the one
// recaptcha_v3 fetched at page load. A v3 token is only valid for about two minutes, so a
// buyer who took longer to fill the account form posted an expired token, failed the
// verification and was bounced to /users/sign_up without an account.
//
// The gem's inline script defines the async execute function named by the value; when it
// is missing (test env, blocked script) the form submits as before. Classic JS only
// (old Babel — no ?./??).
//
// The form is sent exactly once: a second click while the token is on its way is swallowed
// (a native submit would post the stale page-load token, then the fresh one would post
// again), and the gem's wrapper never rejects when grecaptcha.execute fails, so a timeout
// sends the form anyway rather than leaving the button dead.
const TOKEN_TIMEOUT_MS = 5000

export default class extends Controller {
  static values = { function: String }

  submit(event) {
    if (this.submitting) {
      event.preventDefault()
      return
    }
    this.submitting = true
    var fetchToken = window[this.functionValue]
    if (typeof fetchToken !== "function") return

    event.preventDefault()
    var form = this.element
    var sent = false
    var send = function () {
      if (sent) return
      sent = true
      form.submit()
    }
    this.timer = setTimeout(send, TOKEN_TIMEOUT_MS)
    var timer = this.timer

    fetchToken().then(function (token) {
      clearTimeout(timer)
      var input = form.querySelector("input[name^='g-recaptcha-response-data']")
      if (input) input.value = token
      send()
    }, function () {
      clearTimeout(timer)
      send()
    })
  }

  disconnect() {
    clearTimeout(this.timer)
  }
}
